import {
    GET_VENDOR_EMAIL_HISTORY,
    SET_VENDOR_EMAIL_HISTORY,
    GET_VENDOR_EMAIL_HISTORY_MESSAGE,
    SET_VENDOR_EMAIL_HISTORY_MESSAGE
} from './FleetPOVendorEmailHistoryType'

const getFleetVendorEmailHistory = (payload : any) =>({
    type : GET_VENDOR_EMAIL_HISTORY,
    payload
})

const setFleetVendorEmailHistory = (fleetVendorEmailHistory : any) =>({
    type : SET_VENDOR_EMAIL_HISTORY,
    fleetVendorEmailHistory : fleetVendorEmailHistory
})

const getFleetVendorEmailHistoryMessage = (emailHistory : any) =>({
    type : GET_VENDOR_EMAIL_HISTORY_MESSAGE,
    emailHistory
})

const setFleetVendorEmailHistoryMessage = (message : any) =>({
    type : SET_VENDOR_EMAIL_HISTORY_MESSAGE,
    message
})

export {
    getFleetVendorEmailHistory,
    setFleetVendorEmailHistory,
    getFleetVendorEmailHistoryMessage,
    setFleetVendorEmailHistoryMessage
}